import React from "react";
import ProviderOverview from "../kyb-common-components/provider-overview";

const Ai = () => {
    // AI credits are not part of the KYB feature
    return <ProviderOverview provider="ai" feature={null} />;
};

export default Ai;
